import React from 'react';
import drawWorker from './workers/drawWorker.js';
import WebWorker from './workers/workerSetup';
import {UploadData} from '../api/setters'
import {
    Drawer, Button, Radio, Icon,
    Result, Card,Badge ,Modal,
    Typography, Tag, Spin, Divider, message,
    notification, Tooltip,Input 
} from 'antd';
import { Layout} from 'antd';
import { PlusOutlined, DiffOutlined} from '@ant-design/icons';
import { EyeOutlined , DeleteOutlined, EyeInvisibleOutlined ,EditOutlined,
    UndoOutlined ,RedoOutlined, SaveOutlined, SettingOutlined, ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import {
    isBrowser,
    isMobile
    } from "react-device-detect";
import { HotKeys } from "react-hotkeys";
import {Layer} from '../utils/layer'
import {Rig} from './3d/rig'

const { Meta } = Card;
const { Header, Content, Footer } = Layout;
const { info } = Modal;


export class Canvas extends React.Component {
    /**
     * This is the main canvas where a peeps gonna draw
     * @param {T} props 
     */
    constructor(props) {
        super(props);

        var browserZoomRatio = window.devicePixelRatio;
        // If height and width are not set then just use the screen height and width
        var canvHeight = !!this.props.height?this.props.height:window.innerHeight
        var canvWidth = !!this.props.width?this.props.width:window.innerWidth
        var offsetW = !!this.props.width?(window.innerWidth*browserZoomRatio -this.props.width)/2:0
        var offsetH = !!this.props.height?(window.innerHeight*browserZoomRatio-this.props.height)/2:0

        // const base_canvas  = new OffscreenCanvas(100, 1);
        // const ctx = canvas.getContext('2d');

        var baseLayer = {
            "index":0,
            "component":<Layer
                            name="Base Layer"
                            visibility='visible'
                            height={canvHeight}
                            width={canvWidth}
                            isBase={true} // only base layer will have a background. Rest will be transparent
                        />,
            "visible":true,
            "name":"Base Layer"
        }


        this.state = {
            canvHeight:canvHeight,
            canvWidth:canvWidth,
            offsetW:offsetW,
            offsetH:offsetH,
            baseLayer:baseLayer,
            layerList :[],

            activeLayer:baseLayer,

            // props for layer drawer
            layerDrawerVisisble:false,
            currentLayerCount:0,
            layerVisibilityMap : [true, true, true, true, true, true, true, true, true, true], // all visible by defualt
            activeList:[false,false,false,false,false,false,false,false,false,false], //Active tab lookup (i know this is primitive but fuck you)

            // canvas drawing props
            flag : false,
            prevX : 0,
            currX : 0,
            prevY : 0,
            currY : 0,
            dot_flag : false,

            x : "black",
            y : 2,

            // brush props
            brushSize : 1,

            // Canvas Scale (for zoom in and zoom out)
            zoom_scale: 1, 

            // Painting states
            painting:false,
            activeCanvasContext:null,
            offScreenContexts:{}, // Maintain all the offscreen contexts on this dict. Pass only one control at a time

            // History Stack
            // This stack will ultimately be drawing data will be used to generate
            // datasets
            strokeHistory:[],
            strokeUndoReplay:[], // temp buffer to store strokes in case undo pressed
            lastStrokeMemento:[],
            canvasHistDict:{"Base Layer":0}, //will store layer edit count. If layer edits are 0 then will clear layer
            canvasHistory : [], // push into this on component mounting
            maxUndoLimit :40, // Allow only a max of 40 undos for this MVP
            historyPointer:-1, // This will point to the canvas state on Undo/Redo

            // Workers for each fucking layer nibba
            workerLookup:{},

            // Save Modal settings
            save_modal_visible:false,
            save_modal_loading:false,
            artTitle:"",
            titlePresent:false,

            // 3d states
            Drawer3DVisisble:false,

            hideHeader:false

            
        }
        
        this.showFullScreenConfirm = this.showFullScreenConfirm.bind(this)


    }

    


     getTouchPos = (e) => {
            if (!e)
                return false
            if(e.touches) {
                if (e.touches.length == 1) { // Only deal with one finger
                    var touch = e.touches[0]; // Get the information for finger #1
                    return [touch.clientX, touch.clientY]
                }
            }
        }

    getMousePos = (e) =>{
        /**
         * Wow what a beautiful function. Wow. This is amazing.
         * I have created a master piece
         */
        e.persist()
        var doc = document.documentElement;
        var left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
        var top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
        var scrollOffX = (document.body.scrollWidth - window.innerWidth)/2
        var scrollOffY = (document.body.scrollHeight - window.innerHeight)/2
        var browserZoomRatio = window.devicePixelRatio;
        var Xoffset = (window.innerWidth*(1-browserZoomRatio))/2
        var Yoffset = (window.innerHeight*(1-browserZoomRatio))/2
        var newPos = {
            "clientX":e.clientX-Xoffset-(scrollOffX-left),
            "clientY":e.clientY-Yoffset-(scrollOffY-top)
        }
        return newPos
    }

        

        // Add painting listeners
        startTouchPosition = (e) => {
            e.persist()
            var touch = this.getTouchPos(e)
            if(!!!touch){
                return
            }
    
            var off_screen_context = this.getOffScreenContext()
    
            // load the web-worker for active layer
            var webW = this.state.workerLookup[this.state.activeLayer.name]
            var drawWorkerEle = webW.worker
    
            var workerDrawMessage = {
                "message_type":"start",
                "layer_name":this.state.activeLayer.name,
                "x":touch[0]-this.state.offsetW,
                "y": touch[1]-this.state.offsetH,
                "lw":this.state.brushSize,
                "lcap":"round",
                "canvas":off_screen_context
            }
    
            try {
                // You must pass context only once. The next time you send, you should just send the message
                drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]); 
            } catch (error) {
                workerDrawMessage['canvas'] = false
                drawWorkerEle.postMessage(workerDrawMessage);
            }
    
            webW.revoke() // cleanup
                
            this.setState({
                painting:true,
                activeCanvasContext:null
            })
        }

    // Add painting listeners
    startPosition = (e) => {
        e.persist()

        var off_screen_context = this.getOffScreenContext()

        var p2 = this.getMousePos(e)

        // load the web-worker for active layer
        var webW = this.state.workerLookup[this.state.activeLayer.name]
        var drawWorkerEle = webW.worker

        var workerDrawMessage = {
            "message_type":"start",
            "layer_name":this.state.activeLayer.name,
            "x":p2.clientX-this.state.offsetW,
            "y": p2.clientY-this.state.offsetH,
            "lw":this.state.brushSize,
            "lcap":"round",
            "canvas":off_screen_context
        }

        try {
            // You must pass context only once. The next time you send, you should just send the message
            drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]); 
        } catch (error) {
            workerDrawMessage['canvas'] = false
            drawWorkerEle.postMessage(workerDrawMessage);
        }

        webW.revoke() // cleanup
            
        this.setState({
            painting:true,
            activeCanvasContext:null
        })
    }

    finishPosition = (e) => {
        
        this.setState({
            painting:false  
        })
        // Here you do two most important things:
        // 1. Reset the stroke and append to memento and append to stroke history
        // 2. Append the current state of the active layer to the canvas history

        var lastStrokeMemento = this.state.lastStrokeMemento
        lastStrokeMemento.push([]) // [] denotes end of stroke
        var strokeHistory = this.state.strokeHistory
        strokeHistory.push(
            {
                "layer":this.state.activeLayer.name,
                "type":e.type,
                "memento":lastStrokeMemento
            })

        this.setState({
            strokeHistory:strokeHistory,
            lastStrokeMemento :[],// reset the last stroke memento
            strokeUndoReplay:[] 

        })

        // make it such that all the commits or stuff like saving shit to canvas happen in the worker 
        // commit the current canvas state to history
        this.commitCanvasData(this.state.activeLayer.name) // this will push the current layer to hist as well
    }


    // Set mouse events to the canva

    getOffScreenContext = () => {
        // internally will pick up the off-screen context
        var off_screen_context = null
        if(this.state.activeLayer.name in this.state.offScreenContexts){
            off_screen_context = this.state.offScreenContexts[this.state.activeLayer.name]
        }
        else{
            var canv_ctx = document.getElementById(this.state.activeLayer.name).transferControlToOffscreen();
            // console.log(canv_ctx)
            var offScreenContexts = this.state.offScreenContexts
            offScreenContexts[this.state.activeLayer.name] = canv_ctx
            off_screen_context = canv_ctx
            this.setState({
                offScreenContexts:offScreenContexts
            })
        }

        return off_screen_context
    }

    getUndoRedoContext = (layer_name) => {
        // internally will pick up the off-screen context
        var off_screen_context = null
        if(layer_name in this.state.offScreenContexts){
            off_screen_context = this.state.offScreenContexts[layer_name]
        }
        else{
            var canv_ctx = document.getElementById(layer_name).transferControlToOffscreen();
            // console.log(canv_ctx)
            var offScreenContexts = this.state.offScreenContexts
            offScreenContexts[layer_name] = canv_ctx
            off_screen_context = canv_ctx
            this.setState({
                offScreenContexts:offScreenContexts
            })
        }

        return off_screen_context
    }

    // Darw with mouse
    drawMouse = (e) =>{
        
        e.persist();
        // Workerized  drawMouse function
        if(this.state.painting){

            var p2 = this.getMousePos(e)
            // Get offscreen worker
            var off_screen_context = this.getOffScreenContext()
            var workerDrawMessage = {
                "message_type":"draw",
                "layer_name":this.state.activeLayer.name,
                "x":p2.clientX-this.state.offsetW,
                "y": p2.clientY-this.state.offsetH,
                "lw":this.state.brushSize,
                "lcap":"round",
                "canvas":off_screen_context
            }

            // load the web-worker for active layer
            var webW = this.state.workerLookup[this.state.activeLayer.name]
            var drawWorkerEle = webW.worker

            try {
                // You must pass context only once. The next time you send, you should just send the message
                drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]); 
            } catch (error) {
                workerDrawMessage['canvas'] = false
                drawWorkerEle.postMessage(workerDrawMessage);
            }

            // Append to the last stroke memento
            // BEST PART IS THAT I DONT HAVE TO DO THIS VIA A WEB-WORKER
            var lastStroke = this.state.lastStrokeMemento
            lastStroke.push([p2.clientX, p2.clientY, -this.state.offsetW, -this.state.offsetH]) // store offsets seperately
            this.setState({
                lastStrokeMemento:lastStroke
            })

        }
    }


    drawTouch = (e) =>{
        e.persist();
        // Workerized  drawMouse function
        if(this.state.painting){
            var touch = this.getTouchPos(e)
            // console.log(touch)
            if(!!!touch){
                return
            }
            // Get offscreen worker
            var off_screen_context = this.getOffScreenContext()
            var workerDrawMessage = {
                "message_type":"draw",
                "layer_name":this.state.activeLayer.name,
                "x":touch[0]-this.state.offsetW,
                "y": touch[1]-this.state.offsetH,
                "lw":this.state.brushSize,
                "lcap":"round",
                "canvas":off_screen_context
            }

            // load the web-worker for active layer
            var webW = this.state.workerLookup[this.state.activeLayer.name]
            var drawWorkerEle = webW.worker

            try {
                // You must pass context only once. The next time you send, you should just send the message
                drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]); 
            } catch (error) {
                workerDrawMessage['canvas'] = false
                drawWorkerEle.postMessage(workerDrawMessage);
            }

            // Append to the last stroke memento
            // BEST PART IS THAT I DONT HAVE TO DO THIS VIA A WEB-WORKER
            var lastStroke = this.state.lastStrokeMemento
            lastStroke.push([touch[0], touch[1], -this.state.offsetW, -this.state.offsetH]) // store offsets seperately
            this.setState({
                lastStrokeMemento:lastStroke
            })

        }
    }

    // Undo and Redo funcs

    undoAction = () => {
        // Make sure to delete states from your history incase you delete a layer

        // Steps:
        // 1. get the canvas state pointed at by the history pointer -1 (make sure that)
        // 2. Apply that state to the canvas
        // 3. Indicate stroke history to the canvas as well
        var prevHistPointer = this.state.historyPointer-1 // get previous pointer
        var canvasHistDict = this.state.canvasHistDict
    
        if(this.state.prevHistPointer < 0 ){
            message.error("No more states to undo")
            return
        }
        
        var previousCanvasData = this.state.canvasHistory[prevHistPointer]
        // console.log(previousCanvasData)

        var off_screen_context = this.getUndoRedoContext(previousCanvasData[0])
        var workerDrawMessage = {
            "message_type":"undo",
            "undo_data":previousCanvasData[1],
            "canvas":off_screen_context
        }

        // load the web-worker for active layer
        var webW = this.state.workerLookup[previousCanvasData[0]]
        var drawWorkerEle = webW.worker

        try {
            // You must pass context only once. The next time you send, you should just send the message
            drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]); 
        } catch (error) {
            workerDrawMessage['canvas'] = false
            drawWorkerEle.postMessage(workerDrawMessage);
        }

        // undo stroke history
        var stroke_hist = this.state.strokeHistory
        var last_stroke = stroke_hist.splice(-1,1)[0]
        var replayBuffer = this.state.strokeUndoReplay
        replayBuffer.push(last_stroke)

        this.setState({
            historyPointer:prevHistPointer,
            canvasHistDict:canvasHistDict,
            strokeUndoReplay:replayBuffer,
            strokeHistory:stroke_hist
        })
        
    }


    redoAction = () => {
        // TODO
        var nextHistPointer = this.state.historyPointer+1 // get next pointer
        var canvasHistDict = this.state.canvasHistDict

        if(this.state.prevHistPointer >= this.state.canvasHistory.length ){
            message.error("No more states to redo")
            return
        }

        var nextCanvasData = this.state.canvasHistory[nextHistPointer]

        var off_screen_context = this.getUndoRedoContext(nextCanvasData[0])
        var workerDrawMessage = {
            "message_type":"redo",
            "redo_data":nextCanvasData[1],
            "canvas":off_screen_context
        }
        
        // load the web-worker for active layer
        var webW = this.state.workerLookup[nextCanvasData[0]]
        var drawWorkerEle = webW.worker

        try {
            // You must pass context only once. The next time you send, you should just send the message
            drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]); 
        } catch (error) {
            workerDrawMessage['canvas'] = false
            drawWorkerEle.postMessage(workerDrawMessage);
        }

        // append to stroke history if any message in replay buffer
        var replayBuffer = this.state.strokeUndoReplay
        var strokeHist = this.state.strokeHistory
        if(replayBuffer.length!=0){
            var lastUndo = replayBuffer.splice(0,1)[0]
            strokeHist.push(lastUndo)
        }
         
        this.setState({
            historyPointer:nextHistPointer,
            canvasHistDict:canvasHistDict,
            strokeHistory:strokeHist,
            strokeUndoReplay:replayBuffer
        })
        
    }

    showLayerDrawer = () => {
        this.setState({
            layerDrawerVisisble: true,
        });
      };
    
      onLayerDrawerClose = () => {
        this.setState({
            layerDrawerVisisble: false,
        });
      };


      show3DDrawer = () => {
        this.setState({
            Drawer3DVisisble: true,
        });
      };
    
      on3DClose = () => {
        this.setState({
            Drawer3DVisisble: false,
        });
      };

      addLayerAt = (index) =>{
        if(this.state.layerList.length == 10){
            message.destroy()
            message.error('You can have at most 10 layers!')
            return false
        }
        if(index>this.state.layerList.length){
            // allowed to add layer at index = 5 is list length is 5
            message.destroy()
            message.error("Index out of bounds")
            return false
        }

        var layerCount = this.state.currentLayerCount+1
        var layerName = "Layer "+layerCount.toString()

        var canvasHistDict = this.state.canvasHistDict
        canvasHistDict[layerName] = 0

        this.setState({
            canvasHistDict:canvasHistDict
        })
        
        var newLayer = {
            "index":index,
            "component":<Layer
                    name={layerName}
                    visibility={this.state.layerVisibilityMap[index]}
                    height={this.state.canvHeight}
                    width={this.state.canvWidth}
                    isBase={false} // only base layer will have a background. Rest will be transparent
                />,
            "name":layerName,
            "visible":true
        }

        // Add worker for new layer
        var WebW = new WebWorker(drawWorker);
        var workerLookup = this.state.workerLookup
        workerLookup[layerName] = WebW

        // console.log(newLayer)
        this.setState({
            currentLayerCount:layerCount,
            workerLookup:workerLookup
        })
        var layerList = this.state.layerList
        layerList.splice(index, 0, newLayer);

        var canvHist = this.state.canvasHistory
        var can = document.getElementById('blank_canvas')
        var ctx = can.getContext('2d')
        canvHist.push([layerName, ctx.getImageData(0,0,this.state.canvWidth, this.state.canvHeight)])
        this.setState({
          canvasHistory: canvHist,
          historyPointer:this.state.historyPointer+1
        })

        this.setState({
            layerList : layerList
        })

        this.makeActive(newLayer,layerList.indexOf(newLayer))
        message.destroy()
        message.success('New layer added')

        return true
      }


      toggleLayerVis = (index) =>{

        var visibility = this.state.layerVisibilityMap
        visibility[index] = !visibility[index]
        var layerList = this.state.layerList
        layerList[index].visible=!layerList[index].component.props.visibility
        layerList[index].component = React.cloneElement(layerList[index].component,
                {
                    visibility:!layerList[index].component.props.visibility
                }
            )
        this.setState({
            layerVisibilityMap:visibility,
            layerList:layerList
        })

      }

      deleteLayer = (layer) => {
        if(layer.name == "Base Layer"){
            message.destroy()
            message.error("Can't delete the base layer. Sorry for leading you on")
            return false
        }

        var l_name = layer.name
        var l_index = this.state.layerList.indexOf(layer)
        var layerList = this.state.layerList
        
        layerList.splice(l_index, 1)
        

        var activeLayer = l_index>=layerList.length-1?layerList[l_index-1]:layerList[l_index+1]
        // console.log(activeLayer)

        //Delete the worker also
        var workerLookup = this.state.workerLookup
        workerLookup[l_name].terminate(); //termiante the worker before deleting
        delete workerLookup[l_name]

        this.makeActive(activeLayer,layerList.indexOf(activeLayer))
        this.setState({
            layerList:layerList,
            workerLookup:workerLookup
        })
        message.destroy()
        message.info('Deleted: '+l_name)
        return true


      }

      makeActive = (layer, index) =>{
          var active_list = [false,false,false,false,false,false,false,false,false,false]
          active_list[index] = true
          this.setState({
              activeLayer:layer,
              activeList:active_list
          })
      }

      commitListener = (e) => {
          // Call back for the commit data returned by the worker
        //   console.log(e)

        var cdata = e.data.data
        var canvasHist = this.state.canvasHistory
        var historyPointer = this.state.historyPointer+1
        var canvasHistDict = this.state.canvasHistDict
        // This is an elegant line of code. If after a lot of undos, you make a stroke, this will simply reset histroy

        canvasHistDict[e.data.name]+=1 // Maintain a count of edits made to each layer
        canvasHist.length = historyPointer
        
        canvasHist.push([e.data.name, cdata])
        // Add a check to see if history exceed 40 states. if it does, then remove the oldest state
        if(canvasHist.length > this.state.maxUndoLimit){
            canvasHist.shift() // removes the first element
            historyPointer = this.state.maxUndoLimit-1 // History pointer will always stay at the limit if more states come in

        }
        this.setState({
            canvasHistory:canvasHist,
            historyPointer:historyPointer,
            canvasHistDict:canvasHistDict
        })

      }

      commitCanvasData = async (name) =>{
        // This function will commmit the canvas data to canvas history
        
        // Also make sure that you push the state of the default canvas onto the canvas history
        var canvas = document.getElementById('blank_canvas')
        var ctx = canvas.getContext('2d')

        var off_screen_context = this.getOffScreenContext()
        // load the web-worker for active layer
        var webW = this.state.workerLookup[name]
        var drawWorkerEle = webW.worker

        var workerCommitMessage = {
            "message_type":"commit",
            "layer_name":this.state.activeLayer.name,
            "w":this.state.canvWidth,
            "h": this.state.canvHeight,
            "canvas":off_screen_context
        }

        try {
            // You must pass context only once. The next time you send, you should just send the message
            drawWorkerEle.postMessage(workerCommitMessage, [off_screen_context]); 
        } catch (error) {
            workerCommitMessage['canvas'] = false
            drawWorkerEle.postMessage(workerCommitMessage);
        }
        webW.revoke() // cleanup

        var cdata =  await drawWorkerEle.addEventListener('message', this.commitListener, false);  
        // console.log(this.state.canvasHistory)
        return true
      }

      showFullScreenConfirm = (e) => {
        info({
          title: 'Entering full-screen mode',
          content: 'Consider drawing in full-screen mode for best experence. Press back button in case you wish to exit full-screen',
          onOk() {
            document.body.classList.add("no-sroll")
            document.body.requestFullscreen().catch(err => {
                alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
              });
          }
        });
      }

    componentDidMount(){
        // React.initializeTouchEvents(true);
        
        

        // Push the webWorker in state for baseLayer
        var WebW = new WebWorker(drawWorker);
        var workerLookup = this.state.workerLookup
        workerLookup['Base Layer'] = WebW
        // this.drawWorkerEle = this.WebW.worker
          
          // push base layer when canvas is initialized
          var layerList = this.state.layerList
          var baseL = this.state.baseLayer
          layerList.push(baseL)
          var activeList = this.state.activeList
          activeList[0]=true

          this.setState({
              layerList:layerList,
              currentLayerCount:0,
              activeList:activeList,
              workerLookup:workerLookup
          })

          var canvHist = this.state.canvasHistory
          var can = document.getElementById('blank_canvas')
          var ctx = can.getContext('2d')
          canvHist.push(['Base Layer', ctx.getImageData(0,0,this.state.canvWidth, this.state.canvHeight)])

          if (isMobile){
                this.showFullScreenConfirm()
                var offsetH = (window.screen.height-this.state.canvHeight)/2
                var offsetW = (window.screen.width-this.state.canvWidth)/2
                this.setState({
                    offsetH:offsetH,
                    offsetW:offsetW
                })
             }

          this.setState({
            canvasHistory: canvHist,
            historyPointer:this.state.historyPointer+1
          })

      }

      // Modal props
      showSaveModal = () => {
          
        // console.log(this.state.strokeHistory)
        this.setState({
          save_modal_visible: true,
        });
      };
    
      handleSaveModalOk = async () => {
        this.setState({ save_modal_loading: true });
        var device_type = isMobile?"mobile":isBrowser?"pc":"na"
        var status = await UploadData({
            "description":this.state.artTitle,
            "stroke":this.state.strokeHistory,
            "device_type":device_type,
            "canvas_h":this.state.canvHeight,
            "canvas_w":this.state.canvWidth
        })
        if(status){
            this.setState({ save_modal_loading: false, save_modal_visible: false });
        }
        else{
            message.destroy()
            message.error('Could not save the data! Please try again in a minute')
            this.setState({ save_modal_loading: false });
        }
      };
    
      handleSaveModalCancel = () => {
        this.setState({ save_modal_visible: false });
      };

      captureDrawingTitle = (e) => {
          e.persist()
          if(e.target.value == ""){
              this.setState({
                titlePresent:false            
              })
          }
          else{
            this.setState({
                titlePresent:true,
                artTitle:   e.target.value  
              })
          }
      }


      // Scene stamping 
    cropPlusExport = (img,cropX,cropY,cropWidth,cropHeight) =>{
        // create a temporary canvas sized to the cropped size
        var canvas1=document.createElement('canvas');
        var ctx1=canvas1.getContext('2d');
        canvas1.width=cropWidth;
        canvas1.height=cropHeight;
        // use the extended from of drawImage to draw the
        // cropped area to the temp canvas
        ctx1.drawImage(img,cropX,cropY,cropWidth,cropHeight,0,0,cropWidth,cropHeight);
        // return the .toDataURL of the temp canvas
        return(canvas1.toDataURL());
      }

      stampScene = async () =>{
        var canv3d = document.getElementById('3d_canv').firstElementChild;
        var ctx = canv3d.getContext("experimental-webgl", {preserveDrawingBuffer: true});
        var dt = canv3d.toDataURL();

        const imgBlob = await fetch(dt).then( r => r.blob())
        const img = await createImageBitmap(imgBlob, 
            this.state.offsetW, 
            0,
            this.state.canvWidth,
            this.state.canvHeight)

        // damn I'm big genius for this haha
        var YOffset = this.state.offsetH == 0? 65:-(this.state.offsetH-65)

        var off_screen_context = this.getOffScreenContext()
        var workerDrawMessage = {
            "message_type":"stamp",
            "layer_name":this.state.activeLayer.name,
            "stamp":img,
            "y_offset":YOffset,
            "opacity":0.8,
            "canvas":off_screen_context
        }

        // load the web-worker for active layer
        var webW = this.state.workerLookup[this.state.activeLayer.name]
        var drawWorkerEle = webW.worker

        try {
            // You must pass context only once. The next time you send, you should just send the message
            drawWorkerEle.postMessage(workerDrawMessage, [off_screen_context]); 
        } catch (error) {
            workerDrawMessage['canvas'] = false
            drawWorkerEle.postMessage(workerDrawMessage);
        }

        this.on3DClose()
      }

    render() {
        // hotkeys
        const keyMap = {
            TOGGLEHIDE: 'ctrl+shift+h'
        };

        const keyHandlers = {
            TOGGLEHIDE: ()=>{
                message.destroy()
                if(!this.state.hideHeader){
                    message.info("Header is hidden! Press ctrl+shift+h to show again", 3)
                }
                
                this.setState({
                    hideHeader:!this.state.hideHeader
                })
            }
        }
        return (
            <HotKeys keyMap={keyMap} handlers={keyHandlers}>
                <div >
                    <canvas
                            id="blank_canvas"
                        style={{
                                            height:this.state.canvHeight,
                                            width:this.state.canvWidth,
                                        position:'fixed', 
                                        marginLeft:-this.state.canvWidth/2, 
                                        marginTop:-this.props.canvHeight/2}}
                        />
                        <Header style={{ position: 'fixed',
                            zIndex: 1, width: '100%', height:'40px',
                            backgroundColor:'transparent',
                            display:this.state.hideHeader?'none':'block' }}>
                            <div className="logo" />
                            
                            {/* UNDO REDO FUNCTIONS */}

                            <Tooltip placement="bottom" title="Undo">
                            <Button 
                                disabled={this.state.historyPointer>0?false:true}
                                style={{
                                    marginRight:'10px',
                                    backgroundColor:'#ff8c19',
                                    color:'white',
                                }}
                                onClick={this.undoAction}
                            shape='circle' icon={<UndoOutlined />}></Button></Tooltip>

                            <Tooltip placement="bottom" title="Redo">
                            <Button
                            disabled={this.state.historyPointer<this.state.canvasHistory.length-1?false:true}
                            style={{
                                    backgroundColor:'#ff8c19',
                                    color:'white',
                                }}
                                onClick={this.redoAction}
                                shape='circle' icon={<RedoOutlined />}></Button></Tooltip>

                            <Divider type="vertical" />

                            {/* LAYERS FUNCTIONS */}
                            <Tooltip placement="bottom" title="Layers">
                            <Button 
                                style={{
                                    backgroundColor:'#ff8c19',
                                    color:'white',
                                }}
                            shape='circle' icon={<DiffOutlined />}
                            onClick={this.showLayerDrawer}></Button></Tooltip>

                            <Tooltip placement="bottom" title="Save">
                            <Button
                            style={{
                                    marginLeft:'10px',
                                    backgroundColor:'#ff8c19',
                                    color:'white',
                                }}
                                onClick={this.showSaveModal}
                                shape='circle' icon={ <SaveOutlined />}></Button></Tooltip>

                            <Divider type="vertical" />
                        
                        {/* RIG FUNCTIONS */}

                            <Tooltip placement="bottom" title="Rigging">
                            <Button
                            style={{
                                    backgroundColor:'#ff8c19',
                                    color:'white',
                                }}
                                onClick={this.show3DDrawer}
                                shape='circle' >3D</Button></Tooltip>
                        </Header>
                        <Content className="site-layout" style={{ 
                            position:'relative',
                            backgroundColor:'#c1d4fa',
                            height:'100vh',
                            width:'100vw',
                            display: 'table-cell',
                            verticalAlign:'middle'
                            }}>
                    <center>
                        {/* {this.state.baseLayer} */}
                        <div  onTouchStart={this.startTouchPosition}
                            onTouchEnd={this.finishPosition}
                            onTouchMove={this.drawTouch}

                            onMouseDown={this.startPosition}
                            onMouseUp={this.finishPosition}
                            onMouseMove={this.drawMouse}

                            style={{
                                cursor:'crosshair',
                                position:"relative"
                            }}
                            
                            >
                            
                            {this.state.layerList.map(layer => <div 

                                    
                                
                                    >{layer.component}</div>)}
                            
                        </div>

                    </center>

                    <Rig
                    
                        on3DClose={this.on3DClose}
                        Drawer3DVisisble={this.state.Drawer3DVisisble}
                        StampScene={this.stampScene}
                    
                    />

                    <Drawer
                        
                        placement="right"
                        closable={false}
                        onClose={this.onLayerDrawerClose}
                        visible={this.state.layerDrawerVisisble}
                        >
                        <center>
                        <Badge count={this.state.layerList.length} 
                                style={{
                                    backgroundColor:'#ff8c19'
                                }}/>

                        {this.state.layerList.map(layer => <div>
                            <Card
                                hoverable
                                
                                style={{ width: '100%', marginTop: 16 ,
                                        backgroundColor:this.state.activeList[this.state.layerList.indexOf(layer)]?'#429494':null,
                                        
                                        padding:'5px'
                                    }}
                                actions={[<EditOutlined onClick={()=>{this.makeActive(layer, this.state.layerList.indexOf(layer))}}/>,
                                    (layer.visible)?(<EyeOutlined onClick={() => this.toggleLayerVis(this.state.layerList.indexOf(layer))}/>):
                                    (<EyeInvisibleOutlined onClick={() => this.toggleLayerVis(this.state.layerList.indexOf(layer))}/>),
                                    <DeleteOutlined onClick={()=>{this.deleteLayer(layer)}}/>
                                ]}
                                >
                                    <Meta
                                    
                                    title={<div style={{
                                        color:this.state.activeList[this.state.layerList.indexOf(layer)]?'white':'black',
                                    }}>{layer.name}</div>}
                                    />
                                </Card>
                                <p></p>
                                <Button 
                                size='small'
                                style={{
                                    backgroundColor:'#ff8c19',
                                    color:'white'
                                    }}
                                shape='round' icon={<PlusOutlined/>}
                                onClick={()=>{this.addLayerAt(this.state.layerList.indexOf(layer)+1)}}>Add Layer</Button>
                            </div>)}
                        </center>
                        </Drawer>
                        <Modal
                            visible={this.state.save_modal_visible}
                            title="Upload Data"
                            onCancel={this.handleSaveModalCancel}
                            footer={[
                                <Button key="back" onClick={this.handleSaveModalCancel}>
                                Return
                                </Button>,
                                <Button 
                                disabled={(this.state.strokeHistory.length == 0 || !this.state.titlePresent)?true:false}
                                key="submit" 
                                type="primary" 
                                loading={this.state.save_modal_loading} 
                                onClick={this.handleSaveModalOk}>
                                Submit
                                </Button>,
                            ]}
                            >
                            {this.state.strokeHistory.length == 0?
                                        <div>
                                            You haven't drawn anything yet!
                                        </div>:
                                        <div>
                                            <p>

                                            Enter a one-line description to describe what you have drawn.<br/>
                                            An accurate description about your drawing will help generate better models.<br/>

                                            (Please don't channel out your inner poet while creating a description)
                                            </p>
                                            
                                            <Input placeholder="Ex: A dog sitting on a table" 
                                                onChange={this.captureDrawingTitle}
                                            />
                                        </div>
                                    }
                            </Modal>
                    </Content>
                </div>
            </HotKeys>
        );
    }
};